import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Banner } from './admin-ui';
import { settingsError } from '../api/adminSettings';
import { loadShopifyBridge } from '../utils/shopifyBridge';

export const groups = [
  { path: '/cod', label: 'COD' }, { path: '/online', label: 'Online payments' },
  { path: '/integrations', label: 'Integrations' }, { path: '/exchange-rates', label: 'Exchange rates' },
  { path: '/administration', label: 'Administration' },
];
export default function ShopifyNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const menu = useRef(null);
  const embedded = window.self !== window.top;
  const [error, setError] = useState('');
  const [ready, setReady] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!embedded) return;
    let active = true;
    setError('');
    loadShopifyBridge().then(() => { if (active) setReady(true); }).catch(e => { if (active) setError(settingsError(e)); });
    return () => { active = false; };
  }, [embedded, attempt]);
  useEffect(() => {
    const element = menu.current;
    if (!element) return;
    const follow = event => {
      const link = event.target.closest?.('s-link');
      if (!link || !element.contains(link) || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = new URL(link.getAttribute('href'), window.location.origin);
      if (target.origin !== window.location.origin) return;
      event.preventDefault();
      navigate(target.pathname + (target.search || location.search) + target.hash);
    };
    element.addEventListener('click', follow, true);
    return () => element.removeEventListener('click', follow, true);
  }, [ready, navigate, location.search]);
  const href = path => `${path}${location.search}`;
  return <>
    {embedded && ready && <s-app-nav ref={menu}>
      <s-link href="/" rel="home">NinaCheck</s-link>
      <s-link href="/index">Orders</s-link>
      {groups.map(group => <s-link key={group.path} href={group.path}>{group.label}</s-link>)}
    </s-app-nav>}
    {error && <Banner tone="critical" action={{ content: 'Retry', onAction: () => setAttempt(value => value + 1) }}>{error}</Banner>}
    {(!embedded || error) && <nav aria-label="App navigation" className="settings-local-nav">
    <Link to={href('/')} aria-current={location.pathname === '/' ? 'page' : undefined}>NinaCheck</Link>
    <Link to={href('/index')} aria-current={location.pathname === '/index' ? 'page' : undefined}>Orders</Link>
    {groups.map(group => <Link key={group.path} to={href(group.path)} aria-current={location.pathname.startsWith(group.path) ? 'page' : undefined}>{group.label}</Link>)}
    </nav>}
  </>;
}
